import { cx } from '@linaria/core';
import { Link } from '@provider/navigation';
import { Chevron } from '@utils/react';
import { chevronWrapperCls, chevronCls, linkCls } from './all-link.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function AllLink(props) {
  return /*#__PURE__*/jsxs(Link, {
    className: cx(props.className, linkCls),
    href: props.href,
    children: [/*#__PURE__*/jsx("span", {
      className: chevronWrapperCls,
      children: /*#__PURE__*/jsx(Chevron, {
        className: chevronCls,
        size: 8
      })
    }), /*#__PURE__*/jsx("span", {
      children: props.label
    })]
  });
}

export { AllLink };
//# sourceMappingURL=all-link.js.map
